export enum InsurancePayer {
  Self = 'Self',
  AnotherPerson = 'Other',
}
